<template>
  <Modal ref="configModal"
         :size="BootstrapVariant.MEDIUM"
         :static="true"
         :title="tr('performanceOverview.SETTINGS_TITLE')"
         :should-hide-header-close="false"
         title-tag="h5">
    <p>{{ tr('portlet.settings.DESCRIPTION') }}</p>
    <BFormCheckboxGroup v-if="checkboxes.length > 0"
                        v-model="selected"
                        stacked>
      <component :is="item.renderer"
                 v-for="item in checkboxes"
                 :key="item.value"
                 :data="item"></component>
    </BFormCheckboxGroup>
    <template #modal-footer>
      <div>
        <SaveModalButtonGroup @save="onSave"
                              @cancel="onHide"></SaveModalButtonGroup>
      </div>
    </template>
  </Modal>
</template>

<script>
  import { BFormCheckboxGroup } from 'bootstrap-vue';
  import SaveModalButtonGroup from '../../../common/layout/SaveModalButtonGroup.vue';
  import translator from '~/zf/frontend/common/mixins/translator';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import SettingsService from './SettingsService';
  import SettingsOptionRenderer from '../const/SettingsOptionRenderer';
  import Setting from './listItems/Setting.vue';
  import SettingUnavailableToday from './listItems/SettingUnavailableToday.vue';
  import { canView } from '~/zf/frontend/common/acl/AclService';
  import AclModule from '~/zf/frontend/common/acl/const/AclModule';
  import SettingsColumnOptions from '../const/SettingsColumnOptions';
  import SettingOnlyToday from './listItems/SettingOnlyToday.vue';
  import Modal from '../../../common/layout/Modal.vue';

  export default {
    name: 'SettingsModal',
    compatConfig: {
      MODE: 3,
    },
    components: {
      SaveModalButtonGroup,
      Modal,
      BFormCheckboxGroup,
      [SettingsOptionRenderer.SETTINGS]: Setting,
      [SettingsOptionRenderer.SETTINGS_UNAVAILABLE_TODAY]: SettingUnavailableToday,
      [SettingsOptionRenderer.SETTINGS_ONLY_TODAY]: SettingOnlyToday,
    },
    mixins: [translator],
    props: {
      portletUId: {
        required: true,
        type: String,
      },
      columnConfig: {
        required: true,
        type: Object,
      },
    },
    emits: ['change'],
    expose: ['show'],
    data() {
      return {
        selected: [],
        checkboxes: [],
        BootstrapVariant,
        hasMonitoringAccess: false,
      };
    },
    async created() {
      await this.checkMonitoringAclModule();
      const { columnSettings } = this.columnConfig;
      const { columns } = columnSettings;
      this.checkboxes = SettingsColumnOptions.getSettingsColumnOptions(this.hasMonitoringAccess);
      const columnIds = this.checkboxes.map((column) => column.value);
      this.selected = columns.filter((column) => columnIds.includes(column));
    },
    methods: {
      async checkMonitoringAclModule() {
        this.hasMonitoringAccess = await canView(AclModule.MONITORING);
      },
      onSave() {
        const filteredColumns = SettingsService.sortSelected(
          this.selected,
          Object.values(this.columnConfig.columnSettings.all),
        );
        SettingsService.saveColumnSettings(this.portletUId, filteredColumns);
        this.$emit('change', filteredColumns);
        this.onHide();
      },
      show() {
        this.$refs.configModal.show();
      },
      onHide() {
        this.$refs.configModal.hide();
      },
    },
  };
</script>
